import { useMain } from "modules/app/contexts";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FilterOptions } from "./FilterOptions";
import * as S from "./styles";
import * as http from "modules/app/utils/http";

export default function Filters({ isFilterActive }) {
  const {
    setFilterUsers,
    setFilterTags,
    setFilterScope,
    setFilterTeams,
    clearAllFilters,
    updateContacts,
    overwriteTotals,
  } = useMain();

  const [filterModal, setFilterModal] = useState(false);
  const [selectedCompanyTeams, setCompanyTeams] = useState([]);
  const [selectedUsers, setUsers] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedScope, setScope] = useState({});
  const { t } = useTranslation();

  function handleSubmit() {
    const teams = selectedCompanyTeams.reduce(
      (total, team) => (total = [...total, ...team.users]),
      []
    );

    const selectedTeamsNames = selectedCompanyTeams.reduce(
      (total, team) => (total = [...total, team.name]),
      []
    );

    const userIds = selectedUsers.reduce(
      (total, user) => (total = [...total, user.id]),
      []
    );

    const tagIds = selectedTags.reduce(
      (total, tag) => (total = [...total, tag.id]),
      []
    );

    const usersToFilter =
      teams.length > 0
        ? userIds.filter((user) => teams.includes(user))
        : userIds;

    const usersIds = usersToFilter.length != 0 ? usersToFilter : teams;
    const tagsIds = tagIds.length != 0 ? tagIds : [];

    setFilterUsers(usersIds);
    setFilterTags(tagsIds);
    setFilterTeams(selectedTeamsNames);
    setFilterScope(selectedScope);
    handleToggleModal();
  }

  function handleToggleModal() {
    setFilterModal((prevState) => !prevState);
  }

  async function loadCustomersWithoutFilter() {
    const [data, initialTotals] = await http.getAllTabsCustomers();
    updateContacts([...data]);
    overwriteTotals(initialTotals);
  }

  function handleClearFilters() {
    clearAllFilters();
    setCompanyTeams([]);
    setUsers([]);
    setSelectedTags([]);
    setScope({});
    loadCustomersWithoutFilter();
    handleToggleModal();
  }

  return (
    <>
      <S.Container>
        <S.AllFiltersButton
          onClick={handleToggleModal}
          $isFilterActive={isFilterActive}
        >
          {t("Contacts:filter.filtersButton")}
          <S.FilterIcon $isFilterActive={isFilterActive} />
        </S.AllFiltersButton>
      </S.Container>

      {filterModal && (
        <S.ModalOverlay>
          <S.ModalContainer>
            <S.ModalHeader>
              <S.ModalTitle>
                {t("Contacts:filter.filterModalTitle")}
              </S.ModalTitle>
              <S.CloseButton
                onClick={handleToggleModal}
                aria-label="display more actions"
              >
                <S.CloseIcon />
              </S.CloseButton>
            </S.ModalHeader>

            <S.ModalContent>
              <FilterOptions
                setCompanyTeams={setCompanyTeams}
                setUsers={setUsers}
                setSelectedTags={setSelectedTags}
                setScope={setScope}
                selectedCompanyTeams={selectedCompanyTeams}
              />
              <S.ButtonContainer>
                <S.ApplyFilterButton onClick={handleSubmit}>
                  {t("Contacts:filter.applyFilterButton")}
                </S.ApplyFilterButton>
                <S.ClearFilterButton onClick={handleClearFilters}>
                  {t("Contacts:filter.clearFiltersButton")}
                </S.ClearFilterButton>
              </S.ButtonContainer>
            </S.ModalContent>
          </S.ModalContainer>
        </S.ModalOverlay>
      )}
    </>
  );
}
